import { SUPPORTING } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const SupportingPrograms = () => (
    <section
        data-testid="pembinaan-section"
        aria-labelledby="pembinaan-title"
        className="bg-white py-24 sm:py-32"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={SUPPORTING.eyebrow}
                title={SUPPORTING.title}
                testid="pembinaan-title"
            />
            <div className="px-6 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {SUPPORTING.items.map((item, i) => (
                    <Reveal key={item.title} delay={(i % 3) * 0.1}>
                        <article
                            data-testid={`pembinaan-item-${i + 1}`}
                            className="h-full rounded-2xl border border-bh-green/12 bg-bh-offwhite p-7 transition-all duration-300 hover:border-bh-gold/50 hover:bg-white hover:shadow-[0_14px_36px_rgba(16,134,108,0.08)]"
                        >
                            <span className="flex items-center justify-center w-12 h-12 rounded-full bg-bh-light border border-bh-green/15 mb-5">
                                <item.icon className="w-5 h-5 text-bh-green" aria-hidden="true" />
                            </span>
                            <h3 className="text-lg font-bold text-bh-deep mb-2">{item.title}</h3>
                            <p className="text-sm leading-relaxed text-bh-gray">{item.description}</p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
